/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var conf = {
    comments: {
        lineComment: '\\',
        blockComment: ["/*", "*/"]
    },
    brackets: [
        ['{', '}'],
        ['[', ']'],
        ['(', ')']
    ],
    autoClosingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"', close: '"', notIn: ['string'] },
    ],
    surroundingPairs: [
        { open: '{', close: '}' },
        { open: '[', close: ']' },
        { open: '(', close: ')' },
        { open: '"', close: '"' },
    ],
    folding: {
        offSide: true,
        markers: {
            start: new RegExp('^\\s*#region\\b'),
            end: new RegExp('^\\s*#endregion\\b')
        }
    }
};
export var language = {
    defaultToken: 'invalid',
    tokenPostfix: '.8th',
    keywords: [
        '_dup',
        '_mod',
        '_swap',
        '2console',
        '2dip',
        '2drop',
        '2dup',
        '2each',
        '2html',
        '2map',
        '2nk',
        '2over',
        '2swap',
        '3drop',
        '3rev',
        '4drop',
        '8thdir',
        '8thdt',
        '8thsku',
        '8thver',
        '8thvernum',
        'aad',
        'abs',
        'abspath',
        'absrel',
        'accept-pwd',
        'accept',
        'acos',
        'actor',
        'Adar',
        'Adar2',
        'add-func',
        'add',
        'addfont',
        'addrinfo',
        'adjust-dst',
        'aes',
        'aes128box-sig',
        'aes128gcm',
        'aes256box-sig',
        'aes256gcm',
        'aesgcm',
        'affine',
        'again',
        'ahead',
        'alias',
        'all',
        'alloc-and-read',
        'alloc-buf',
        'and',
        'ansi',
        'anti-alias',
        'any-clicked',
        'any',
        'append',
        'appname',
        'approx',
        'approximates',
        'apropos',
        'arg',
        'argc',
        'args',
        'arm',
        'arr',
        'array',
        'asin',
        'assert',
        'asset',
        'associate',
        'atan',
        'atan2',
        'atime',
        'atlas',
        'atrun',
        'auth-string',
        'auth',
        'Av',
        'band',
        'base',
        'base64',
        'basedir',
        'begin',
        'between',
        'bfloat',
        'bi',
        'bic',
        'BIGE',
        'BIGPI',
        'binary',
        'bind-exec',
        'bind',
        'bint',
        'binv',
        'bit',
        'bitmap',
        'bits',
        'bk',
        'black',
        'blakehash',
        'blue',
        'bnot',
        'bor',
        'bounds',
        'bp',
        'break',
        'breakif',
        'bsearch',
        'btree',
        'buf',
        'build',
        'buildver',
        'button-color',
        'button-label',
        'button-set-behavior',
        'button-symbol-label',
        'button-symbol',
        'button',
        'bxor',
        'by-name',
        'bye',
        'byte',
        'c/does',
        'c#',
        'call',
        'camera-img',
        'camera-limits',
        'camera',
        'canwrite',
        'case',
        'caseof',
        'cast',
        'catch',
        'cb',
        'CBC',
        'ceil',
        'center',
        'centroid',
        'CFB',
        'chacha20box-sig',
        'chachapoly',
        'chart-add-slot-colored',
        'chart-add-slot',
        'chart-begin-colored',
        'chart-begin',
        'chart-end',
        'chart-push-slot',
        'chart-push',
        'chdir',
        'checkbox',
        'chmod',
        'cipher',
        'clamp',
        'clear',
        'clicked',
        'clip',
        'clone-shallow',
        'clone',
        'close-this',
        'close',
        'closed',
        'clreol',
        'cls',
        'cmp',
        'code',
        'col',
        'cold',
        'color-picker',
        'color',
        'comb',
        'combo-begin-color',
        'combo-begin-label',
        'combo-cb',
        'combo-end',
        'combo',
        'commit',
        'compile',
        'compiling',
        'compress',
        'conflict',
        'conj',
        'connect',
        'console',
        'const',
        'constant',
        'container',
        'contextual-begin',
        'contextual-close',
        'contextual-end',
        'contextual-item-image-text',
        'contextual-item-symbol-text',
        'contextual-item-text',
        'conv',
        'copy',
        'copydir',
        'cor-drop',
        'cor',
        'cos',
        'cosd',
        'counting-allocations',
        'countries',
        'cp',
        'cpe',
        'cpu',
        'cr',
        'create',
        'crop',
        'ctime',
        'CTR',
        'curlang',
        'current',
        'curry',
        'curtask',
        'cyan',
        'd',
        'data',
        'datadir',
        'dawn',
        'day',
        'days-in-hebrew-year',
        'debug',
        'decimal',
        'decrypt',
        'def-queue',
        'def-stack',
        'default-size',
        'default',
        'defer',
        'deferred',
        'deg',
        'del',
        'delete',
        'deprecate',
        'depth',
        'desat',
        'det',
        'device',
        'DGRAM',
        'dh-genkey',
        'dh-secret',
        'dh-sign',
        'dh-verify',
        'dhm',
        'die',
        'diff',
        'dim',
        'dip',
        'dir',
        'display-info',
        'display',
        'displaying-hebrew',
        'displays',
        'displaysize',
        'dlcall',
        'dlopen',
        'dlsym',
        'dname',
        'do-dawn',
        'do-dusk',
        'do-rise',
        'do',
        'done',
        'dot',
        'double',
        'dow',
        'down',
        'doy',
        'draw-image-at',
        'draw-image-centered',
        'draw-image',
        'draw-sub-image',
        'draw-text-high',
        'draw-text-wrap',
        'draw-text',
        'drop',
        'dst',
        'dstack',
        'dump',
        'dup',
        'dusk',
        'E',
        'e#',
        'each-slice',
        'each',
        'eachbuf',
        'eachline',
        'ebox-sig',
        'ECB',
        'ecc-genkey',
        'ecc-secret',
        'ecc-sign',
        'ecc-verify',
        'edbox-sig',
        'edbox',
        'edge',
        'edges',
        'edit-focus',
        'edit-string',
        'elapsed-timer-seconds',
        'elapsed-timer',
        'else',
        'Elul',
        'emod',
        'encrypt',
        'end',
        'enssep',
        'ensurekey',
        'enum',
        'eof',
        'epoch',
        'err',
        'errno',
        'error',
        'eval',
        'eval0',
        'event-boost',
        'event-msec',
        'event-wait',
        'event',
        'except-task',
        'exec-cb',
        'exec-name',
        'exec',
        'exec#',
        'execnull',
        'exename',
        'exists',
        'exp',
        'expand',
        'expect',
        'expm1',
        'expmod',
        'extra',
        'false',
        'fetch-full',
        'fetch-uid-mail',
        'ffi',
        'ffifail',
        'field',
        'file',
        'fill-arc',
        'fill-circle',
        'fill-poly',
        'fill-rect-color',
        'fill-rect',
        'fill-triangle',
        'fill',
        'fillrect',
        'filter',
        'find',
        'first-dow',
        'fixed',
        'FLAG',
        'flags',
        'flip',
        'float',
        'floor',
        'flush',
        'fmod',
        'fmt',
        'fname',
        'fnv',
        'forget',
        'format',
        'fourth',
        'frac',
        'free',
        'Fri',
        'from-svg',
        'fullscreen',
        'func',
        'gcd',
        'gcm-tag-size',
        'GCM',
        'gen-nonce',
        'generate',
        'genkey',
        'get-n',
        'get-row-height',
        'get-sub',
        'get',
        'getaddrinfo',
        'getb',
        'getc',
        'getcwd',
        'getenv',
        'getfont',
        'getline',
        'getmap',
        'getmod',
        'getmsg',
        'getpeername',
        'getq',
        'gets',
        'getxy',
        'gl',
        'glob-nocase',
        'glob',
        'go',
        'gotoxy',
        'gpio-mmap',
        'gpio',
        'green',
        'grid-push',
        'grid',
        'group-begin',
        'group-end',
        'group-scroll-ofs',
        'group',
        'handler',
        'hanukkah',
        'hash',
        'head',
        'header',
        'hebepoch',
        'hebrew-epoch',
        'hebrew',
        'hebrewtoday',
        'help',
        'Heshvan',
        'hex',
        'high',
        'hmac',
        'hmonth-name',
        'homedir',
        'hook',
        'hotp',
        'hour',
        'hovered',
        'i',
        'id',
        'id2ns',
        'idd',
        'ident',
        'if',
        'ifaces',
        'ignore',
        'im',
        'image',
        'img',
        'in',
        'include',
        'indexof',
        'INET4',
        'INET6',
        'Inf',
        'info',
        'init',
        'input-button',
        'input-key',
        'input-motion',
        'input-scroll',
        'input-string',
        'insert',
        'int',
        'interp',
        'intersect',
        'inv',
        'invmod',
        'is',
        'isa',
        'islamic',
        'islamictoday',
        'items-used',
        'iter-all',
        'iter',
        'iv',
        'Iyar',
        'jcall',
        'jclass',
        'jdn',
        'jmethod',
        'join',
        'json-8th',
        'json-nesting',
        'json-pretty',
        'json-throw',
        'json',
        'k32',
        'keep',
        'key-down',
        'key-pressed',
        'key-released',
        'key',
        'keys',
        'kill',
        'kind',
        'Kislev',
        'l',
        'label-colored',
        'label-wrap-colored',
        'label-wrap',
        'label',
        'last-day-of-hebrew-month',
        'last-dow',
        'last-month',
        'last-rowid',
        'last-week',
        'last-year',
        'last',
        'latitude',
        'launch',
        'layout-bounds',
        'layout-grid-begin',
        'layout-grid-end',
        'layout-push-dynamic',
        'layout-push-static',
        'layout-push-variable',
        'layout-ratio-from-pixel',
        'layout-reset-row-height',
        'layout-row-begin',
        'layout-row-dynamic',
        'layout-row-end',
        'layout-row-height',
        'layout-row-push',
        'layout-row-static',
        'layout-row-template-begin',
        'layout-row-template-end',
        'layout-row',
        'layout-space-begin',
        'layout-space-end',
        'layout-space-push',
        'layout-widget-bounds',
        'lcm',
        'left',
        'len',
        'lib',
        'libbin',
        'libc',
        'line-info',
        'link',
        'list-begin',
        'list-end',
        'list-new',
        'list-range',
        'list',
        'listen',
        'listener',
        'literal',
        'ln',
        'ln1p',
        'load-history',
        'local',
        'locals',
        'lock-to',
        'lock',
        'locked',
        'log-syslog',
        'log-task',
        'log-time-local',
        'log-time',
        'log',
        'login',
        'logout',
        'long-days',
        'long-months',
        'long-name',
        'long',
        'longitude',
        'longjmp',
        'lookup',
        'loop-',
        'loop',
        'lowmem',
        'ls',
        'm',
        'mac',
        'magenta',
        'main',
        'make-style',
        'map',
        'mark',
        'max-exceptions',
        'max-vertex-element',
        'max',
        'md-init',
        'md-parse',
        'mean',
        'mean&variance',
        'measure-font',
        'measure',
        'median',
        'mem',
        'memfree',
        'menu-begin',
        'menu-close',
        'menu-end',
        'menu-item-image',
        'menu-item-label',
        'menu-item-symbol',
        'menubar-begin',
        'menubar-end',
        'merge',
        'min',
        'minor',
        'mkdir',
        'mmap-range',
        'mmap',
        'mobile',
        'mod',
        'mode',
        'model',
        'Mon',
        'mouse-pos',
        'move',
        'msec',
        'msgdlg',
        'mtime',
        'mv',
        'mysql',
        'n',
        'n*',
        'n#',
        'name',
        'NaN',
        'nbuf',
        'ndrop',
        'needs',
        'neg',
        'neighbors',
        'net-socket',
        'new-minor',
        'new',
        'next-arg',
        'next-dow',
        'next-month',
        'next-week',
        'next-year',
        'next',
        'nip',
        'Nissan',
        'node-edges',
        'node',
        'nodes',
        'noop',
        'not',
        'nothrow',
        'notify',
        'notimpl',
        'ns',
        'null',
        'number',
        'oa',
        'odbc',
        'odd',
        'of',
        'OFB',
        'off',
        'oid',
        'okey',
        'omer',
        'on',
        'onBlack',
        'onBlue',
        'oncrash',
        'onCyan',
        'onexit',
        'onGreen',
        'only',
        'onMagenta',
        'onRed',
        'onWhite',
        'onYellow',
        'op',
        'open-ro',
        'open',
        'option',
        'opts',
        'or',
        'orientation',
        'os-names',
        'os',
        'over',
        'oversample',
        'p',
        'pack',
        'pad',
        'params',
        'parent',
        'parse-approx',
        'parse-csv',
        'parse-html',
        'parse-range',
        'parse-stream',
        'parse',
        'parsech',
        'parseln',
        'parsews',
        'peek',
        'perm',
        'pesach',
        'PI',
        'pick',
        'pid',
        'pix',
        'pixels',
        'plot-fn',
        'plot',
        'poke',
        'poll',
        'pool-clear-all',
        'pool-clear',
        'pop-font',
        'pop',
        'popen',
        'popup-begin',
        'popup-close',
        'popup-end',
        'popup-scroll-ofs',
        'port-is-ssl',
        'pos',
        'post-main',
        'post',
        'pre-main',
        'prep-name',
        'prepare',
        'prev-dow',
        'prev',
        'prime',
        'print',
        'prior',
        'priority',
        'private',
        'process-args-fancy',
        'process-args-help',
        'process-args-vars',
        'process-args',
        'progress',
        'prompt',
        'prop-int',
        'property',
        'PROTO_TCP',
        'PROTO_UDP',
        'proxy',
        'pt',
        'pts',
        'public',
        'purim',
        'push-font',
        'push',
        'put',
        'putc',
        'puts',
        'putslim',
        'q-notify',
        'q-wait',
        'qlen',
        'qsort',
        'quantize',
        'query-all',
        'query',
        'quote',
        'r',
        'rad',
        'raise',
        'rand-jit',
        'rand-jsf',
        'rand-native',
        'rand-normal',
        'rand-pcg-seed',
        'rand-pcg',
        'rand-range',
        'rand-select',
        'rand',
        'randbuf-pcg',
        'randbuf',
        'randeach',
        'randkey',
        'random',
        'range',
        'rdrop',
        're',
        'read-all',
        'read',
        'rect-center',
        'rect-intersect',
        'rect-ofs',
        'rect-pad',
        'rect-shrink',
        'rect-union',
        'rect',
        'recurse-stack',
        'recurse',
        'recvfrom',
        'red',
        'redir',
        'reduce',
        'ref',
        'reg',
        'regbin',
        'rekey',
        'released',
        'relpath',
        'remaining-args',
        'remove',
        'render',
        'repeat',
        'request-perm',
        'required',
        'requires',
        'reset',
        'restart',
        'restore',
        'result',
        'resumed',
        'rev',
        'rglob',
        'ri',
        'right',
        'rm',
        'rmdir',
        'roll',
        'rollback',
        'root-certs',
        'root',
        'rop',
        'rosh-chodesh',
        'rosh-hashanah',
        'rot',
        'rot32l',
        'rot32r',
        'rotate',
        'round',
        'round2',
        'rounding',
        'row',
        'rpick',
        'rroll',
        'rsa_decrypt',
        'rsa_encrypt',
        'rsa_sign',
        'rsa_verify',
        'rsabox-sig',
        'rsabox',
        'rsagenkey',
        'rstack',
        'rswap',
        'running-variance-finalize',
        'running-variance',
        'rusage',
        's-truncate',
        's',
        'same-size',
        'same',
        'Sat',
        'save-history',
        'save',
        'sbox-sig',
        'scale',
        'scancode',
        'screen-saver',
        'screen-size',
        'screen-win-close',
        'screen',
        'scriptdir',
        'scriptfile',
        'scroll',
        'search',
        'SED-CHECK',
        'SED',
        'seek',
        'select-inbox',
        'selectable',
        'sem-post',
        'sem-rm',
        'sem-wait',
        'sem',
        'semi-throw',
        'sendto',
        'sensor',
        'sep',
        'server',
        'set-affinity',
        'set-font',
        'set-num-vertices',
        'set-sub',
        'set-wipe',
        'set',
        'setenv',
        'setjmp',
        'setpos',
        'setq',
        'setsockopt',
        'settings',
        'setwin',
        'sgn',
        'sh',
        'sha1-hmac',
        'shard',
        'shavuot',
        'shear',
        'Shevat',
        'shift',
        'shl',
        'shmem',
        'short-days',
        'short-months',
        'shr',
        'shuffle',
        'signal',
        'sin',
        'sind',
        'Sivan',
        'size',
        'sleep-until',
        'sleep',
        'slice',
        'slide',
        'slider-int',
        'slider',
        'slog',
        'slurp',
        'smear',
        'socket',
        'sort',
        'space',
        'spacing',
        'sparse',
        'spit',
        'splice',
        'sql',
        'sqr',
        'sqrt',
        'stack-check',
        'stack-size',
        'standalone',
        'start-timer',
        'start',
        'stat',
        'stats',
        'stderr',
        'stdin',
        'stdout',
        'step',
        'sthrow',
        'stop',
        'STREAM',
        'string',
        'stroke-arc',
        'stroke-circle',
        'stroke-curve',
        'stroke-line',
        'stroke-polygon',
        'stroke-polyline',
        'stroke-rect',
        'stroke-tri',
        'struct',
        'style-from-table',
        'subdir',
        'Sun',
        'sunrise',
        'suspended',
        'sw-gl',
        'swap',
        'sysquit',
        'taanit-esther',
        'tab-hook',
        'tag',
        'Tammuz',
        'tan',
        'tand',
        'task-n',
        'task-stop',
        'task',
        'tell-conflict',
        'tell',
        'tempdir',
        'tempfilename',
        'terminated',
        'Tevet',
        'text',
        'then',
        'third',
        'throw',
        'thrownull',
        'Thu',
        'ticks',
        'ticks/sec',
        'time',
        'timer-ctrl',
        'timer',
        'times',
        'tisha-beav',
        'Tishrei',
        'tlog',
        'tlshello',
        'tmpspit',
        'TODO',
        'tooltip',
        'totp-epoch',
        'totp-time-step',
        'totp',
        'trace-enter',
        'trace-leave',
        'trace-word',
        'trace',
        'trans',
        'translate',
        'trap',
        'trash',
        'traverse',
        'tree-pop',
        'tree-state-push',
        'tri',
        'trie',
        'true',
        'trunc',
        'truncate',
        'tuck',
        'Tue',
        'txt',
        'type-check',
        'typeassert',
        'tzadjust',
        'uid',
        'uname',
        'undo',
        'ungetb',
        'ungetc',
        'union',
        'unique',
        'unix',
        'unknown',
        'unlock',
        'unpack',
        'unpad',
        'unshard',
        'until',
        'unzip-entry',
        'unzip',
        'up',
        'updatetz',
        'url',
        'use-style',
        'user-agent',
        'uuid',
        'validate-pgp-sig',
        'vals',
        'var',
        'ver',
        'vsync',
        'wait',
        'watch',
        'Wed',
        'weight',
        'when',
        'while',
        'white',
        'wide',
        'widget-bounds',
        'widget-fitting',
        'widget-high',
        'widget-hovered',
        'widget-mouse-click-down',
        'widget-mouse-clicked',
        'widget-pos',
        'widget-size',
        'widget-wide',
        'widget',
        'win-bounds',
        'win-close',
        'win-closed',
        'win-collapse',
        'win-collapsed',
        'win-content-bounds',
        'win',
        'with',
        'word',
        'words-like',
        'words',
        'writable',
        'write',
        'writen',
        'x-each',
        'x',
        'xchg',
        'xform',
        'xor',
        'y',
        'year',
        'yellow',
        'yield',
        'ymd',
        'yom-haatsmaut',
        'yom-kippur',
        'zip',
        'zipentry',
        'zipnew',
        'zipopen',
        'zipsave',
    ],
    builtins: [

    ],
    typeKeywords: [],
    brackets: [
        { open: '{', close: '}', token: 'delimiter.curly' },
        { open: '[', close: ']', token: 'delimiter.bracket' },
        { open: '(', close: ')', token: 'delimiter.parenthesis' }
    ],
    tokenizer: {
        root: [
            { include: '@whitespace' },
            { include: '@numbers' },
            { include: '@strings' },
            [/[,:;]/, 'delimiter'],
            [/[{}\[\]()]/, '@brackets'],
            [/@[a-zA-Z_]\w*/, 'tag'],
            [
                /[a-zA-Z_]\w*/,
                {
                    cases: {
                        '@keywords': 'keyword',
                        '@builtins': 'type.identifier',
                        '@default': 'identifier'
                    }
                }
            ]
        ],
        // Deal with white space, including single and multi-line comments
        whitespace: [
            [/\s+/, 'white'],
            [/(\\.*$)/, 'comment'],
            [/\/\*/, 'comment', '@comment'],
        ],
        comment: [
            [/[^\/*]+/, 'comment'],
            [/\*\//, 'comment', '@pop'],
            [/[\/*]/, 'comment']
        ],
        // Recognize hex, negatives, decimals, imaginaries, longs, and scientific notation
        numbers: [
            [/-?0x([abcdef]|[ABCDEF]|\d)+[lL]?/, 'number.hex'],
            [/-?[BFX]?(\d*\.)?\d+([eE][+\-]?\d+)?[jJ]?[lL]?/, 'number']
        ],
        // Recognize strings, including those broken across lines with \ (but not without)
        strings: [
            [/"$/, 'string.escape', '@popall'],
            [/"/, 'string.escape', '@dblStringBody']
        ],
        dblStringBody: [
            [/[^\\"]+$/, 'string', '@popall'],
            [/[^\\"]+/, 'string'],
            [/\\./, 'string'],
            [/"/, 'string.escape', '@popall'],
            [/\\$/, 'string']
        ]
    }
};
